import { render, staticRenderFns } from "./VerticalTab.vue?vue&type=template&id=e538e522"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports